export default __webpack_public_path__ + "static/media/wishlist-nav.443c4bf1.svg";